import Alpine from "alpinejs";

// PLUGINS
import collapse from "@alpinejs/collapse";
import focus from "@alpinejs/focus";
import intersect from "@alpinejs/intersect";
import morph from "@alpinejs/morph";
import ui from "@alpinejs/ui";
import dialog from "./plugins/dialog";

Alpine.plugin(collapse);
Alpine.plugin(focus);
Alpine.plugin(intersect);
Alpine.plugin(morph);
Alpine.plugin(ui);
Alpine.plugin(dialog);

import history from "./plugins/history";
import share from "./plugins/share";

Alpine.plugin(history);
Alpine.plugin(share);

// STORES
import cart from "./stores/cart";
Alpine.store("cart", cart);

// COMPONENTS
import media from "./components/media";
Alpine.data("media", media);

import product from "./components/product";
Alpine.data("product", product);

import productRecommendations from "./components/productRecommendations";
Alpine.data("productRecommendations", productRecommendations);

import numberInput from "./components/numberInput";
Alpine.data("numberInput", numberInput);

import validation from "./components/validation";
Alpine.data("validation", validation);

import phoneInput from "./components/phoneInput";
Alpine.data("phoneInput", phoneInput);

import slider from "./components/slider";
Alpine.data("slider", slider);

import buildProcessLinks from "./components/build-process-links";
Alpine.data("buildProcessLinks", buildProcessLinks);

import collectionFilters from "./components/collectionFilters";
Alpine.data("collectionFilters", collectionFilters);

import predictiveSearch from "./components/predictiveSearch";
Alpine.data("predictiveSearch", predictiveSearch);

import aiChat from "./ai-chat/ai-chat";
Alpine.data("aiChat", aiChat);

import siteForm from "./components/siteForm";
Alpine.data("siteForm", siteForm);


window.Alpine = Alpine;

// INIT
Alpine.start();
